import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication-service';
import { jwtDecode } from 'jwt-decode';
import { ApplicationConfigService } from 'app/core/config/application-config.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private applicationConfigService: ApplicationConfigService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const serverApiUrl = this.applicationConfigService.getEndpointFor('');

    if (!req.url || (req.url.startsWith('http') && !(serverApiUrl && req.url.startsWith(serverApiUrl)))) {
      return next.handle(req);
    }

    const token = AuthenticationService.getStoredToken();

    if (token) {
      if (!sessionStorage.getItem(AuthenticationService.USER_NAME_SESSION_ATTRIBUTE)) {
        const decodedToken: any = jwtDecode(token);
        sessionStorage.setItem(AuthenticationService.USER_NAME_SESSION_ATTRIBUTE, decodedToken.sub);
        sessionStorage.setItem(AuthenticationService.NUM_PESSOA_SESSION_ATTRIBUTE, decodedToken.numPessoa);
      }

      const clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next.handle(clonedRequest);
    }

    return next.handle(req);
  }
}
